/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Core {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description Authenticate a user locally. Only available in development and QA environments.
   *
   * @tags Core
   * @name AuthenticateLocal
   * @summary Local Login
   * @request POST:/api/core/auth/local
   */
  authenticateLocal = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/local`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Check the availability and configuration status of all supported auth providers.
   *
   * @tags Core
   * @name GetProvidersStatus
   * @summary Get Authentication Providers Status
   * @request GET:/api/core/auth/providers
   */
  getProvidersStatus = (params = {}) =>
    this.http.request({
      path: `/api/core/auth/providers`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Register a new user account with email and password.
   *
   * @tags Core
   * @name SignupWithPassword
   * @summary Email & Password Signup
   * @request POST:/api/core/auth/signup
   */
  signupWithPassword = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/signup`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Authenticate using email and password.
   *
   * @tags Core
   * @name LoginWithPassword
   * @summary Email & Password Login
   * @request POST:/api/core/auth/login
   */
  loginWithPassword = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/login`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Generate and email a single-use login link.
   *
   * @tags Core
   * @name RequestMagicLink
   * @summary Request Magic Link
   * @request POST:/api/core/auth/magic-link/request
   */
  requestMagicLink = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/magic-link/request`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Verify magic link token and exchange for authenticated JWT session.
   *
   * @tags Core
   * @name VerifyMagicLink
   * @summary Verify Magic Link
   * @request POST:/api/core/auth/magic-link/verify
   */
  verifyMagicLink = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/magic-link/verify`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Initiate password reset by sending a one-time reset link.
   *
   * @tags Core
   * @name RequestPasswordReset
   * @summary Request Password Reset
   * @request POST:/api/core/auth/password-reset/request
   */
  requestPasswordReset = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/password-reset/request`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Confirm password reset with valid token and set new password.
   *
   * @tags Core
   * @name ConfirmPasswordReset
   * @summary Confirm Password Reset
   * @request POST:/api/core/auth/password-reset/confirm
   */
  confirmPasswordReset = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/password-reset/confirm`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve the profile of the currently authenticated user.
   *
   * @tags Core
   * @name GetCurrentUserInfo
   * @summary Get Current User
   * @request GET:/api/core/auth/me
   * @secure
   */
  getCurrentUserInfo = (params = {}) =>
    this.http.request({
      path: `/api/core/auth/me`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Exchange a valid refresh token for a new access token and refresh token pair.
   *
   * @tags Core
   * @name RefreshToken
   * @summary Refresh Token
   * @request POST:/api/core/auth/refresh
   */
  refreshToken = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/refresh`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Authenticate or register via Apple Identity Token (JWT). Validates RS256 signature against Apple JWKS, extracts user subject, and links or creates user account.
   *
   * @tags Core
   * @name AuthenticateApple
   * @summary Apple Sign-In / Signup
   * @request POST:/api/core/auth/apple
   */
  authenticateApple = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/apple`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Authenticate or register via Google ID token. Links to existing account with matching verified email.
   *
   * @tags Core
   * @name AuthenticateGoogle
   * @summary Google OAuth Login / Signup
   * @request POST:/api/core/auth/social/google
   */
  authenticateGoogle = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/social/google`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Authenticate or register via Facebook Graph access token.
   *
   * @tags Core
   * @name AuthenticateFacebook
   * @summary Facebook OAuth Login / Signup
   * @request POST:/api/core/auth/social/facebook
   */
  authenticateFacebook = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/social/facebook`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Authenticate or register via Instagram access token.
   *
   * @tags Core
   * @name AuthenticateInstagram
   * @summary Instagram OAuth Login / Signup
   * @request POST:/api/core/auth/social/instagram
   */
  authenticateInstagram = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/social/instagram`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Send a 6-digit OTP verification code via WhatsApp or Twilio SMS.
   *
   * @tags Core
   * @name SendMessagingOtp
   * @summary Send OTP via WhatsApp or SMS
   * @request POST:/api/core/auth/messaging/send-otp
   */
  sendMessagingOtp = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/messaging/send-otp`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Verify a 6-digit OTP code sent via WhatsApp or SMS to authenticate or complete signup.
   *
   * @tags Core
   * @name VerifyMessagingOtp
   * @summary Verify OTP via WhatsApp or SMS
   * @request POST:/api/core/auth/messaging/verify-otp
   */
  verifyMessagingOtp = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/messaging/verify-otp`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Generate WebAuthn PublicKeyCredentialCreationOptions for registering a new passkey. Requires authenticated user session.
   *
   * @tags Core
   * @name GetPasskeyRegisterOptions
   * @summary Get Passkey Registration Options
   * @request POST:/api/core/auth/passkeys/register/options
   * @secure
   */
  getPasskeyRegisterOptions = (params = {}) =>
    this.http.request({
      path: `/api/core/auth/passkeys/register/options`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Verify browser attestation response and persist newly registered passkey credential.
   *
   * @tags Core
   * @name VerifyPasskeyRegistration
   * @summary Verify Passkey Registration Attestation
   * @request POST:/api/core/auth/passkeys/register/verify
   * @secure
   */
  verifyPasskeyRegistration = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/passkeys/register/verify`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Generate WebAuthn PublicKeyCredentialRequestOptions for passkey authentication (discoverable credential).
   *
   * @tags Core
   * @name GetPasskeyAuthenticateOptions
   * @summary Get Passkey Authentication Options
   * @request POST:/api/core/auth/passkeys/authenticate/options
   */
  getPasskeyAuthenticateOptions = (params = {}) =>
    this.http.request({
      path: `/api/core/auth/passkeys/authenticate/options`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Verify browser assertion response and authenticate user session via passkey.
   *
   * @tags Core
   * @name VerifyPasskeyAuthentication
   * @summary Verify Passkey Authentication Assertion
   * @request POST:/api/core/auth/passkeys/authenticate/verify
   */
  verifyPasskeyAuthentication = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/passkeys/authenticate/verify`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Generate new TOTP secret key, QR code URI, and single-use backup recovery codes. Requires authenticated user session.
   *
   * @tags Core
   * @name SetupTotpMfa
   * @summary Initiate TOTP MFA Setup
   * @request POST:/api/core/auth/mfa/totp/setup
   * @secure
   */
  setupTotpMfa = (params = {}) =>
    this.http.request({
      path: `/api/core/auth/mfa/totp/setup`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Confirm and activate TOTP MFA on user account by verifying initial 6-digit authenticator code.
   *
   * @tags Core
   * @name ConfirmTotpMfa
   * @summary Confirm TOTP MFA Setup
   * @request POST:/api/core/auth/mfa/totp/confirm
   * @secure
   */
  confirmTotpMfa = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/mfa/totp/confirm`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Verify 6-digit TOTP or SMS code against temporary MFA challenge token to complete login.
   *
   * @tags Core
   * @name VerifyMfaChallenge
   * @summary Verify MFA Challenge Token
   * @request POST:/api/core/auth/mfa/challenge/verify
   */
  verifyMfaChallenge = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/mfa/challenge/verify`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Redeem single-use backup recovery code against temporary MFA challenge token to complete login.
   *
   * @tags Core
   * @name VerifyMfaBackupCode
   * @summary Verify MFA Backup Recovery Code
   * @request POST:/api/core/auth/mfa/backup-code/verify
   */
  verifyMfaBackupCode = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/mfa/backup-code/verify`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Initialize an anonymous guest session token for prospects starting rental applications or scheduling property tours prior to user registration.
   *
   * @tags Core
   * @name CreateGuestSession
   * @summary Create Anonymous Guest Session
   * @request POST:/api/core/auth/guest-session
   */
  createGuestSession = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/guest-session`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve current guest session metadata and saved draft application / booking state.
   *
   * @tags Core
   * @name GetGuestSession
   * @summary Retrieve Guest Session Draft State
   * @request GET:/api/core/auth/guest-session
   */
  getGuestSession = (query, params = {}) =>
    this.http.request({
      path: `/api/core/auth/guest-session`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Persist or update guest rental application or booking draft data for the active guest session.
   *
   * @tags Core
   * @name UpdateGuestSessionDraft
   * @summary Update Guest Session Draft State
   * @request PUT:/api/core/auth/guest-session/draft
   */
  updateGuestSessionDraft = (data, query, params = {}) =>
    this.http.request({
      path: `/api/core/auth/guest-session/draft`,
      method: "PUT",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Migrate guest draft data and associate the guest session with the newly registered or logged-in user.
   *
   * @tags Core
   * @name ClaimGuestSession
   * @summary Claim Guest Session & Migrate Data
   * @request POST:/api/core/auth/guest-session/claim
   * @secure
   */
  claimGuestSession = (data, params = {}) =>
    this.http.request({
      path: `/api/core/auth/guest-session/claim`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve a list of all supported countries and their configurations.
   *
   * @tags Core
   * @name GetCountries
   * @summary Get Countries
   * @request GET:/api/core/countries
   */
  getCountries = (params = {}) =>
    this.http.request({
      path: `/api/core/countries`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve the configuration for a specific country by its ISO code.
   *
   * @tags Core
   * @name GetCountry
   * @summary Get Country
   * @request GET:/api/core/countries/{country_code}
   */
  getCountry = (countryCode, params = {}) =>
    this.http.request({
      path: `/api/core/countries/${countryCode}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve all active sovereign market profiles.
   *
   * @tags Core
   * @name ListMarketProfiles
   * @summary List Market Profiles
   * @request GET:/api/core/market-profiles
   */
  listMarketProfiles = (params = {}) =>
    this.http.request({
      path: `/api/core/market-profiles`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve a sovereign market profile by market code.
   *
   * @tags Core
   * @name GetMarketProfile
   * @summary Get Market Profile
   * @request GET:/api/core/market-profiles/{market_code}
   */
  getMarketProfile = (marketCode, params = {}) =>
    this.http.request({
      path: `/api/core/market-profiles/${marketCode}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Core
   * @name ValidateTaxIdentifier
   * @summary Validate Tax Identifier
   * @request POST:/api/core/tax-identifiers/validate
   */
  validateTaxIdentifier = (data, params = {}) =>
    this.http.request({
      path: `/api/core/tax-identifiers/validate`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve summary statistics for the organization's property management dashboard.
   *
   * @tags Core
   * @name GetDashboard
   * @summary Get Dashboard Stats
   * @request GET:/api/core/dashboard/stats
   * @secure
   */
  getDashboard = (params = {}) =>
    this.http.request({
      path: `/api/core/dashboard/stats`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve unified operational cockpit with persona-aware priority queue and telemetry.
   *
   * @tags Core
   * @name GetDashboardCockpit
   * @summary Get Dashboard Cockpit
   * @request GET:/api/core/dashboard/cockpit
   * @secure
   */
  getDashboardCockpit = (params = {}) =>
    this.http.request({
      path: `/api/core/dashboard/cockpit`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve actionable work items tailored to the active persona context.
   *
   * @tags Core
   * @name GetPriorityQueue
   * @summary Get Priority Work Queue
   * @request GET:/api/core/dashboard/priority-queue
   * @secure
   */
  getPriorityQueue = (query, params = {}) =>
    this.http.request({
      path: `/api/core/dashboard/priority-queue`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve the profile of the currently authenticated user.
   *
   * @tags Core
   * @name GetMyProfile
   * @summary Get My Profile
   * @request GET:/api/core/users/profile
   * @secure
   */
  getMyProfile = (params = {}) =>
    this.http.request({
      path: `/api/core/users/profile`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update the profile information of the currently authenticated user.
   *
   * @tags Core
   * @name UpdateMyProfile
   * @summary Update My Profile
   * @request PUT:/api/core/users/profile
   * @secure
   */
  updateMyProfile = (data, params = {}) =>
    this.http.request({
      path: `/api/core/users/profile`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Partially update profile information of the currently authenticated user.
   *
   * @tags Core
   * @name PatchMyProfile
   * @summary Patch My Profile
   * @request PATCH:/api/core/users/profile
   * @secure
   */
  patchMyProfile = (data, params = {}) =>
    this.http.request({
      path: `/api/core/users/profile`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Alias for /profile to support standard consumer conventions.
   *
   * @tags Core
   * @name GetMyProfileMe
   * @summary Get My Profile Me
   * @request GET:/api/core/users/me
   * @deprecated
   * @secure
   */
  getMyProfileMe = (params = {}) =>
    this.http.request({
      path: `/api/core/users/me`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Partially update profile information of the currently authenticated user.
   *
   * @tags Core
   * @name PatchMyProfile2
   * @summary Patch My Profile
   * @request PUT:/api/core/users/me
   * @deprecated
   * @originalName patchMyProfile
   * @duplicate
   * @secure
   */
  patchMyProfile2 = (data, params = {}) =>
    this.http.request({
      path: `/api/core/users/me`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Partially update profile information of the currently authenticated user.
   *
   * @tags Core
   * @name PatchMyProfile3
   * @summary Patch My Profile
   * @request PATCH:/api/core/users/me
   * @deprecated
   * @originalName patchMyProfile
   * @duplicate
   * @secure
   */
  patchMyProfile3 = (data, params = {}) =>
    this.http.request({
      path: `/api/core/users/me`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Initialize user organization during onboarding, defaulting organization name to user full name if omitted or empty.
   *
   * @tags Core
   * @name InitializeOrganization
   * @summary Initialize Organization
   * @request POST:/api/core/users/organization/initialize
   * @secure
   */
  initializeOrganization = (data, params = {}) =>
    this.http.request({
      path: `/api/core/users/organization/initialize`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve details of the organization the current user belongs to.
   *
   * @tags Core
   * @name GetMyOrganization
   * @summary Get My Organization
   * @request GET:/api/core/users/organization
   * @secure
   */
  getMyOrganization = (params = {}) =>
    this.http.request({
      path: `/api/core/users/organization`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update settings and information for the current user's organization.
   *
   * @tags Core
   * @name UpdateMyOrganization
   * @summary Update My Organization
   * @request PUT:/api/core/users/organization
   * @secure
   */
  updateMyOrganization = (data, params = {}) =>
    this.http.request({
      path: `/api/core/users/organization`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all users who are members of the current user's organization.
   *
   * @tags Core
   * @name GetTeamMembers
   * @summary Get Team Members
   * @request GET:/api/core/users/organization/users
   * @secure
   */
  getTeamMembers = (params = {}) =>
    this.http.request({
      path: `/api/core/users/organization/users`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Register or update an APNs / FCM push notification token for the current user.
   *
   * @tags Core
   * @name RegisterDeviceToken
   * @summary Register Device Push Token
   * @request POST:/api/core/users/device-tokens
   * @secure
   */
  registerDeviceToken = (data, params = {}) =>
    this.http.request({
      path: `/api/core/users/device-tokens`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Initiate self-serve GDPR erasure and account deletion. If sole owner, requires explicit organization deletion confirmation.
   *
   * @tags Core
   * @name DeleteMyAccountGdpr
   * @summary Self-Serve GDPR Account & Data Deletion
   * @request POST:/api/core/users/me/gdpr/delete
   * @secure
   */
  deleteMyAccountGdpr = (data, params = {}) =>
    this.http.request({
      path: `/api/core/users/me/gdpr/delete`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List issues for the current organization.
   *
   * @tags Core
   * @name ListIssues
   * @summary List Issues
   * @request GET:/api/core/issues
   * @secure
   */
  listIssues = (params = {}) =>
    this.http.request({
      path: `/api/core/issues`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new issue for the current organization.
   *
   * @tags Core
   * @name CreateIssue
   * @summary Create Issue
   * @request POST:/api/core/issues
   * @secure
   */
  createIssue = (data, params = {}) =>
    this.http.request({
      path: `/api/core/issues`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve a single issue by ID.
   *
   * @tags Core
   * @name GetIssue
   * @summary Get Issue
   * @request GET:/api/core/issues/{issue_id}
   * @secure
   */
  getIssue = (issueId, params = {}) =>
    this.http.request({
      path: `/api/core/issues/${issueId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update status, priority, or metadata for an issue.
   *
   * @tags Core
   * @name UpdateIssue
   * @summary Update Issue
   * @request PATCH:/api/core/issues/{issue_id}
   * @secure
   */
  updateIssue = (issueId, data, params = {}) =>
    this.http.request({
      path: `/api/core/issues/${issueId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Assign or unassign an issue.
   *
   * @tags Core
   * @name AssignIssue
   * @summary Assign Issue
   * @request POST:/api/core/issues/{issue_id}/assign
   * @secure
   */
  assignIssue = (issueId, data, params = {}) =>
    this.http.request({
      path: `/api/core/issues/${issueId}/assign`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Request a new approval workflow for an entity.
   *
   * @tags Core
   * @name RequestApproval
   * @summary Request Approval
   * @request POST:/api/core/approvals
   * @secure
   */
  requestApproval = (data, params = {}) =>
    this.http.request({
      path: `/api/core/approvals`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List approvals for the organization with optional filters.
   *
   * @tags Core
   * @name ListApprovals
   * @summary List Approvals
   * @request GET:/api/core/approvals
   * @secure
   */
  listApprovals = (query, params = {}) =>
    this.http.request({
      path: `/api/core/approvals`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List pending approvals for the organization, optionally filtered by assignee.
   *
   * @tags Core
   * @name ListPendingApprovals
   * @summary List Pending Approvals
   * @request GET:/api/core/approvals/pending
   * @secure
   */
  listPendingApprovals = (query, params = {}) =>
    this.http.request({
      path: `/api/core/approvals/pending`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List approvals associated with a specific entity.
   *
   * @tags Core
   * @name ListApprovalsForEntity
   * @summary List Approvals For Entity
   * @request GET:/api/core/approvals/entity/{entity_type}/{entity_id}
   * @secure
   */
  listApprovalsForEntity = (entityType, entityId, params = {}) =>
    this.http.request({
      path: `/api/core/approvals/entity/${entityType}/${entityId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get approval details by ID.
   *
   * @tags Core
   * @name GetApproval
   * @summary Get Approval
   * @request GET:/api/core/approvals/{approval_id}
   * @secure
   */
  getApproval = (approvalId, params = {}) =>
    this.http.request({
      path: `/api/core/approvals/${approvalId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Submit approval action for an approval workflow.
   *
   * @tags Core
   * @name Approve
   * @summary Approve
   * @request POST:/api/core/approvals/{approval_id}/approve
   * @secure
   */
  approve = (approvalId, data, params = {}) =>
    this.http.request({
      path: `/api/core/approvals/${approvalId}/approve`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Submit rejection action for an approval workflow.
   *
   * @tags Core
   * @name Reject
   * @summary Reject
   * @request POST:/api/core/approvals/{approval_id}/reject
   * @secure
   */
  reject = (approvalId, data, params = {}) =>
    this.http.request({
      path: `/api/core/approvals/${approvalId}/reject`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Cancel an active approval workflow.
   *
   * @tags Core
   * @name Cancel
   * @summary Cancel
   * @request POST:/api/core/approvals/{approval_id}/cancel
   * @secure
   */
  cancel = (approvalId, data, params = {}) =>
    this.http.request({
      path: `/api/core/approvals/${approvalId}/cancel`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Request clarification on a pending approval step directly by step_id.
   *
   * @tags Core
   * @name RequestStepClarification
   * @summary Request clarification on an approval step
   * @request POST:/api/core/approvals/steps/{step_id}/request-clarification
   * @secure
   */
  requestStepClarification = (stepId, data, params = {}) =>
    this.http.request({
      path: `/api/core/approvals/steps/${stepId}/request-clarification`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Request clarification on a pending approval step.
   *
   * @tags Core
   * @name ClarifyApprovalStep
   * @summary Clarify Approval Step
   * @request POST:/api/core/approvals/{approval_id}/steps/{step_id}/clarify
   * @secure
   */
  clarifyApprovalStep = (approvalId, stepId, data, params = {}) =>
    this.http.request({
      path: `/api/core/approvals/${approvalId}/steps/${stepId}/clarify`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Platform admin intervention to override an approval workflow.
   *
   * @tags Core
   * @name InterveneApproval
   * @summary Intervene Approval
   * @request POST:/api/core/approvals/{approval_id}/intervene
   * @secure
   */
  interveneApproval = (approvalId, data, params = {}) =>
    this.http.request({
      path: `/api/core/approvals/${approvalId}/intervene`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Perform a permission-scoped hybrid vector and full-text keyword search across Homy items (Properties, Rentals, Tasks, Maintenance Requests, and Listings).
   *
   * @tags Core
   * @name SearchQuery
   * @summary Perform Scoped Global Search
   * @request GET:/api/core/search
   * @secure
   */
  searchQuery = (query, params = {}) =>
    this.http.request({
      path: `/api/core/search`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new workflow pipeline.
   *
   * @tags Core
   * @name CreatePipeline
   * @summary Create Pipeline
   * @request POST:/api/core/pipelines
   * @secure
   */
  createPipeline = (data, params = {}) =>
    this.http.request({
      path: `/api/core/pipelines`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all workflow pipelines for the current organization.
   *
   * @tags Core
   * @name ListPipelines
   * @summary List Pipelines
   * @request GET:/api/core/pipelines
   * @secure
   */
  listPipelines = (query, params = {}) =>
    this.http.request({
      path: `/api/core/pipelines`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Seed the default rental pipeline and stages for the organization.
   *
   * @tags Core
   * @name SeedDefaultPipeline
   * @summary Seed Default Pipeline
   * @request POST:/api/core/pipelines/seed-default
   * @secure
   */
  seedDefaultPipeline = (params = {}) =>
    this.http.request({
      path: `/api/core/pipelines/seed-default`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get pipeline details including stages and transition rules.
   *
   * @tags Core
   * @name GetPipeline
   * @summary Get Pipeline
   * @request GET:/api/core/pipelines/{pipeline_id}
   * @secure
   */
  getPipeline = (pipelineId, params = {}) =>
    this.http.request({
      path: `/api/core/pipelines/${pipelineId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update pipeline details.
   *
   * @tags Core
   * @name UpdatePipeline
   * @summary Update Pipeline
   * @request PATCH:/api/core/pipelines/{pipeline_id}
   * @secure
   */
  updatePipeline = (pipelineId, data, params = {}) =>
    this.http.request({
      path: `/api/core/pipelines/${pipelineId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a workflow pipeline.
   *
   * @tags Core
   * @name DeletePipeline
   * @summary Delete Pipeline
   * @request DELETE:/api/core/pipelines/{pipeline_id}
   * @secure
   */
  deletePipeline = (pipelineId, params = {}) =>
    this.http.request({
      path: `/api/core/pipelines/${pipelineId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Add a new stage to a pipeline.
   *
   * @tags Core
   * @name AddStage
   * @summary Add Stage
   * @request POST:/api/core/pipelines/{pipeline_id}/stages
   * @secure
   */
  addStage = (pipelineId, data, params = {}) =>
    this.http.request({
      path: `/api/core/pipelines/${pipelineId}/stages`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update an existing stage in a pipeline.
   *
   * @tags Core
   * @name UpdateStage
   * @summary Update Stage
   * @request PATCH:/api/core/pipelines/{pipeline_id}/stages/{stage_id}
   * @secure
   */
  updateStage = (pipelineId, stageId, data, params = {}) =>
    this.http.request({
      path: `/api/core/pipelines/${pipelineId}/stages/${stageId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a stage from a pipeline.
   *
   * @tags Core
   * @name DeleteStage
   * @summary Delete Stage
   * @request DELETE:/api/core/pipelines/{pipeline_id}/stages/{stage_id}
   * @secure
   */
  deleteStage = (pipelineId, stageId, params = {}) =>
    this.http.request({
      path: `/api/core/pipelines/${pipelineId}/stages/${stageId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Reorder stages in a pipeline.
   *
   * @tags Core
   * @name ReorderStages
   * @summary Reorder Stages
   * @request POST:/api/core/pipelines/{pipeline_id}/stages/reorder
   * @secure
   */
  reorderStages = (pipelineId, data, params = {}) =>
    this.http.request({
      path: `/api/core/pipelines/${pipelineId}/stages/reorder`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Add a transition constraint rule between two stages.
   *
   * @tags Core
   * @name AddTransition
   * @summary Add Transition
   * @request POST:/api/core/pipelines/{pipeline_id}/transitions
   * @secure
   */
  addTransition = (pipelineId, data, params = {}) =>
    this.http.request({
      path: `/api/core/pipelines/${pipelineId}/transitions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a stage transition rule.
   *
   * @tags Core
   * @name DeleteTransition
   * @summary Delete Transition
   * @request DELETE:/api/core/pipelines/{pipeline_id}/transitions/{transition_id}
   * @secure
   */
  deleteTransition = (pipelineId, transitionId, params = {}) =>
    this.http.request({
      path: `/api/core/pipelines/${pipelineId}/transitions/${transitionId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Create a new automation rule for a pipeline/stage.
   *
   * @tags Core
   * @name CreateAutomationRule
   * @summary Create Automation Rule
   * @request POST:/api/core/automation-rules
   * @secure
   */
  createAutomationRule = (data, params = {}) =>
    this.http.request({
      path: `/api/core/automation-rules`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List automation rules with optional filters.
   *
   * @tags Core
   * @name ListAutomationRules
   * @summary List Automation Rules
   * @request GET:/api/core/automation-rules
   * @secure
   */
  listAutomationRules = (query, params = {}) =>
    this.http.request({
      path: `/api/core/automation-rules`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get automation rule details.
   *
   * @tags Core
   * @name GetAutomationRule
   * @summary Get Automation Rule
   * @request GET:/api/core/automation-rules/{rule_id}
   * @secure
   */
  getAutomationRule = (ruleId, params = {}) =>
    this.http.request({
      path: `/api/core/automation-rules/${ruleId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an automation rule.
   *
   * @tags Core
   * @name UpdateAutomationRule
   * @summary Update Automation Rule
   * @request PATCH:/api/core/automation-rules/{rule_id}
   * @secure
   */
  updateAutomationRule = (ruleId, data, params = {}) =>
    this.http.request({
      path: `/api/core/automation-rules/${ruleId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an automation rule.
   *
   * @tags Core
   * @name DeleteAutomationRule
   * @summary Delete Automation Rule
   * @request DELETE:/api/core/automation-rules/{rule_id}
   * @secure
   */
  deleteAutomationRule = (ruleId, params = {}) =>
    this.http.request({
      path: `/api/core/automation-rules/${ruleId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Test dispatch an event and execute all matching active automation rules.
   *
   * @tags Core
   * @name TestDispatchEvent
   * @summary Test Dispatch Event
   * @request POST:/api/core/automation-rules/test-dispatch
   * @secure
   */
  testDispatchEvent = (query, params = {}) =>
    this.http.request({
      path: `/api/core/automation-rules/test-dispatch`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve notifications for the current authenticated user.
   *
   * @tags Core
   * @name ListUserNotifications
   * @summary List User Notifications
   * @request GET:/api/core/notifications
   * @secure
   */
  listUserNotifications = (query, params = {}) =>
    this.http.request({
      path: `/api/core/notifications`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Mark an individual notification as read.
   *
   * @tags Core
   * @name MarkNotificationRead
   * @summary Mark Notification Read
   * @request PATCH:/api/core/notifications/{notification_id}/read
   * @secure
   */
  markNotificationRead = (notificationId, params = {}) =>
    this.http.request({
      path: `/api/core/notifications/${notificationId}/read`,
      method: "PATCH",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Mark all unread notifications for current user as read.
   *
   * @tags Core
   * @name MarkAllNotificationsRead
   * @summary Mark All Notifications Read
   * @request POST:/api/core/notifications/read-all
   * @secure
   */
  markAllNotificationsRead = (params = {}) =>
    this.http.request({
      path: `/api/core/notifications/read-all`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new CRM contact.
   *
   * @tags Core
   * @name CreateContact
   * @summary Create Contact
   * @request POST:/api/core/contacts
   * @secure
   */
  createContact = (data, params = {}) =>
    this.http.request({
      path: `/api/core/contacts`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List CRM contacts with optional type and text search filters.
   *
   * @tags Core
   * @name ListContacts
   * @summary List Contacts
   * @request GET:/api/core/contacts
   * @secure
   */
  listContacts = (query, params = {}) =>
    this.http.request({
      path: `/api/core/contacts`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get single CRM contact details.
   *
   * @tags Core
   * @name GetContact
   * @summary Get Contact
   * @request GET:/api/core/contacts/{contact_id}
   * @secure
   */
  getContact = (contactId, params = {}) =>
    this.http.request({
      path: `/api/core/contacts/${contactId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update CRM contact details.
   *
   * @tags Core
   * @name UpdateContact
   * @summary Update Contact
   * @request PATCH:/api/core/contacts/{contact_id}
   * @secure
   */
  updateContact = (contactId, data, params = {}) =>
    this.http.request({
      path: `/api/core/contacts/${contactId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a CRM contact.
   *
   * @tags Core
   * @name DeleteContact
   * @summary Delete Contact
   * @request DELETE:/api/core/contacts/{contact_id}
   * @secure
   */
  deleteContact = (contactId, params = {}) =>
    this.http.request({
      path: `/api/core/contacts/${contactId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Record an inbound lead capture event for this contact.
   *
   * @tags Core
   * @name RecordLeadCapture
   * @summary Record Lead Capture
   * @request POST:/api/core/contacts/{contact_id}/lead-captures
   * @secure
   */
  recordLeadCapture = (contactId, data, params = {}) =>
    this.http.request({
      path: `/api/core/contacts/${contactId}/lead-captures`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all lead captures recorded for this contact.
   *
   * @tags Core
   * @name ListLeadCaptures
   * @summary List Lead Captures
   * @request GET:/api/core/contacts/{contact_id}/lead-captures
   * @secure
   */
  listLeadCaptures = (contactId, params = {}) =>
    this.http.request({
      path: `/api/core/contacts/${contactId}/lead-captures`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Set or update property search preferences for this contact.
   *
   * @tags Core
   * @name UpsertSearchProfile
   * @summary Upsert Search Profile
   * @request POST:/api/core/contacts/{contact_id}/search-profile
   * @secure
   */
  upsertSearchProfile = (contactId, data, params = {}) =>
    this.http.request({
      path: `/api/core/contacts/${contactId}/search-profile`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get property search preferences for this contact.
   *
   * @tags Core
   * @name GetSearchProfile
   * @summary Get Search Profile
   * @request GET:/api/core/contacts/{contact_id}/search-profile
   * @secure
   */
  getSearchProfile = (contactId, params = {}) =>
    this.http.request({
      path: `/api/core/contacts/${contactId}/search-profile`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get active properties matching this contact's search profile.
   *
   * @tags Core
   * @name GetMatchedProperties
   * @summary Get Matched Properties
   * @request GET:/api/core/contacts/{contact_id}/matched-properties
   * @secure
   */
  getMatchedProperties = (contactId, query, params = {}) =>
    this.http.request({
      path: `/api/core/contacts/${contactId}/matched-properties`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve catalog of granular system RBAC permissions with category groupings and descriptions.
   *
   * @tags Core
   * @name ListPermissions
   * @summary List RBAC System Permissions
   * @request GET:/api/core/permissions
   * @secure
   */
  listPermissions = (query, params = {}) =>
    this.http.request({
      path: `/api/core/permissions`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve catalog of default system roles and their granted permission sets.
   *
   * @tags Core
   * @name ListRoles
   * @summary List RBAC Default Roles
   * @request GET:/api/core/roles
   * @secure
   */
  listRoles = (params = {}) =>
    this.http.request({
      path: `/api/core/roles`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create Share Link.
   *
   * @tags Core
   * @name CreateShareLink
   * @summary Create Share Link
   * @request POST:/api/core/share-links
   * @secure
   */
  createShareLink = (data, params = {}) =>
    this.http.request({
      path: `/api/core/share-links`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Revoke Share Link.
   *
   * @tags Core
   * @name RevokeShareLink
   * @summary Revoke Share Link
   * @request DELETE:/api/core/share-links/{link_id}
   * @secure
   */
  revokeShareLink = (linkId, params = {}) =>
    this.http.request({
      path: `/api/core/share-links/${linkId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Get OAuth Authorize Information.
   *
   * @tags Core
   * @name GetOAuthAuthorizeInfo
   * @summary OAuth Authorize Info
   * @request GET:/api/core/oauth/authorize
   */
  getOAuthAuthorizeInfo = (query = {}, params = {}) =>
    this.http.request({
      path: `/api/core/oauth/authorize`,
      method: "GET",
      query,
      format: "json",
      ...params,
    });
  /**
   * @description Authorize OAuth Client and issue authorization code.
   *
   * @tags Core
   * @name AuthorizeOAuth
   * @summary Authorize OAuth Client
   * @request POST:/api/core/oauth/authorize
   * @secure
   */
  authorizeOAuth = (data, params = {}) =>
    this.http.request({
      path: `/api/core/oauth/authorize`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
